
import { defineComponent, PropType } from 'vue'
import Avatar from '@/components/Avatar.vue'
import { CommentType, MemberType } from '@/types/entities'
import { mapState } from 'vuex'
export default defineComponent({
  props: {
    comment: {
      type: Object as PropType<CommentType>
    }
  },
  inject: ['taskMembers'],
  components: {
    Avatar
  },
  methods: {
    handleEditComment () {
      // write code to edit comment
    },
    handleDeleteComment () {
      // write code to delete comment
    }
  },
  computed: {
    ...mapState(['currentBoard']),
    commenter () {
      return this.currentBoard.members.find((tm: MemberType) => tm._id === this.comment.creator)
    }
  }
})
